import { useEffect } from "react";

import { StepsDataProps, ValidBoxLabelsProps } from "types/boundingBoxesContextTypes";
import { Detector } from "types/detectors";
import { CanvasAnnotation } from "types/imageAnnotations";
import { ImageQuery } from "types/imageQueries";
import { generateId } from "utils/generateId";
import { colors } from "utils/roiConversion";

interface IUseSetBBoxesData {
  data: ImageQuery | undefined;
  detector: Detector | undefined;
  setStepsData: React.Dispatch<React.SetStateAction<StepsDataProps>>;
  setValidBoxLabels: React.Dispatch<React.SetStateAction<ValidBoxLabelsProps[]>>;
  validBoxLabels: ValidBoxLabelsProps[];
  rois: CanvasAnnotation[];
  isBoundingBoxes?: boolean;
}

const useBoxLabelAndStepData = (props: IUseSetBBoxesData) => {
  const { data, detector, setStepsData, setValidBoxLabels, validBoxLabels, rois, isBoundingBoxes } = props;

  // update the annotations state for current label
  useEffect(() => {
    if (!rois) return;
    const mapData = validBoxLabels.map((item) => ({
      ...item,
      items: [...rois],
    }));
    setValidBoxLabels(mapData);
    setStepsData((data) => ({ ...data, currentStep: data.totalSteps }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rois, setValidBoxLabels]);

  useEffect(() => {
    if (data) {
      const currentPredictor = detector;
      if (isBoundingBoxes) {
        const validBoxes = currentPredictor?.valid_bbox_labels || [];
        const convertToValidBoxes = validBoxes.map((labelText, idx) => ({
          id: generateId(),
          label: labelText,
          type: "Box",
          color: colors[idx] || "#0DFFF7",
          items: [],
        }));

        setStepsData({
          currentStep: 1,
          totalSteps: validBoxes.length || 0,
        });
        setValidBoxLabels(convertToValidBoxes);
        return;
      }
      setStepsData({
        currentStep: 0,
        totalSteps: 0,
      });
      setValidBoxLabels([]);
    }
  }, [data, detector, setStepsData, setValidBoxLabels, isBoundingBoxes]);
};

export default useBoxLabelAndStepData;
